import { render, staticRenderFns } from "./ty.vue?vue&type=template&id=2f044bc8&"
import script from "./ty.vue?vue&type=script&lang=js&"
export * from "./ty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports